import React, { FC } from "react";
import { Price } from "../../../../../types";
import { Box, Typography } from "@mui/material";

import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import { useTranslation } from "react-i18next";

interface PriceItemProps {
  price: Price;
  gridTemplateColumns?: string;
}

export const PriceItem: FC<PriceItemProps> = ({
  price,
  gridTemplateColumns = "1fr",
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          height: "40px",
          borderBottom: "1px solid #e0e0e0",
          display: { xs: "none", sm: "none", md: "grid" },
          gridTemplateColumns: gridTemplateColumns,
          px: "24px",
          paddingBottom: "8px",
          paddingTop: "8px",
          background: "#fff",
          "&:hover": {
            background: "#f5f5f5",
          },
          "&:active": {
            background: "#f5f5f5",
          },
          "&:last-child": {
            borderBottom: "none",
            borderRadius: "0 0 16px 16px",
            mb: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
          }}
        >
          <StackedBarChartIcon sx={{ color: "#666666", mr: "8px" }} />
          <Typography
            sx={{
              width: "80%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#666666",
            }}
          >
            {price.level || "-"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
          }}
        >
          <Typography
            sx={{
              width: "80%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#666666",
            }}
          >
            ${price.views_price} / {t("prices.views")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          height: "40px",
          borderBottom: "1px solid #e0e0e0",
          display: { xs: "flex", sm: "flex", md: "none" },
          flexDirection: "column",
          justifyContent: "center",
          px: "12px",
          paddingBottom: "8px",
          paddingTop: "8px",
          background: "#fff",
          "&:hover": {
            background: "#f5f5f5",
          },
          "&:active": {
            background: "#f5f5f5",
          },
          "&:last-child": {
            borderBottom: "none",
            borderRadius: "0 0 16px 16px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <StackedBarChartIcon sx={{ color: "#666666", mr: "8px" }} />
            <Typography
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: "#666666",
              }}
            >
              {price.level || "-"}
            </Typography>
          </Box>

          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#666666",
            }}
          >
            ${price.views_price} / {t("prices.views")}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
